<template>
  <div class="lazy-image"
       :class="class_list"
       @click="$emit('click', $event)">
    <img :class="{thumbs_lazy: lazy_src}"
         :src="src"
         v-bind="get_attributes"
         class="lazy-image_thumb"
         :alt="alt">
    <img v-if="loaded"
         @load="showLazyImage"
         class="lazy-image_origin"
         v-bind="get_attributes"
         :src="lazy_src"
         :alt="alt">
  </div>
</template>

<script>
import ssr, {ssr_window} from "../../helpers/ssr";
export default {
  name: "LazyImage",
  mixins: [ssr],
  props: {
    src: {
      type: String,
      required: true
    },
    alt:{
      type: String,
      default: 'image'
    },
    lazy_src:{
      type: String,
      default: ''
    },
    cover_img: {
      type: Boolean,
      default: false
    },
    lazy_attr: {
      type: Boolean,
      default: false
    },
    img_border_radius: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    class_list() {
      return {
        has_lazy_src: this.lazy_src,
        cover_img: this.cover_img,
        show_lazy: this.show_lazy,
        img_border_radius: this.img_border_radius,
        hide_thumb_png: this.hide_thumb_png
      }
    },
    get_attributes() {
      if (!this.lazy_src) return
      return {
        loading: 'lazy'
      }
    },
    hide_thumb_png() {
      if (!this.lazy_src) return false
      let is_png = this.src.split('.').pop()
      return is_png === 'png'
    },
  },
  data() {
    return {
      loaded: false,
      show_lazy: false
    }
  },
  mounted() {
    if (!this.lazy_src) return
    ssr_window.addEventListener('scroll', this.scrollEvent)
    this.scrollEvent()
  },
  destroyed() {
    this.destroyScrollEvent()
  },
  methods: {
    scrollEvent() {
      let {top} = this.$el.getBoundingClientRect()
      if((top - this.window_innerHeight) < 0) {
        this.loaded = true
        this.destroyScrollEvent()
      }
    },
    destroyScrollEvent() {
      this.destroyResizeEvent()
      ssr_window.removeEventListener('scroll', this.scrollEvent)
    },
    showLazyImage() {
      this.show_lazy = true
    },
    setLoaded() {
      this.loaded = true
    }
  }
}
</script>
